import React from 'react';
import { SelectOptionType } from 'types';

type SearchBarContextProps = {
    destinations: SelectOptionType[] | SelectOptionType | null,
    setDestinations: (destinations: SelectOptionType[] | SelectOptionType | null) => void,
    duration: number | null,
    setDuration: (duration: number | null) => void,
    startDate: Date | null,
    setStartDate: (startDate: Date | null) => void,
    endDate: Date | null,
    setEndDate: (endDate: Date | null) => void,
    roomCategory: string | null,
    setRoomCategory: (roomCategory: string | null) => void,
    product: string | null,
    setProduct: (product: string | null) => void,
    nbAdults: number,
    setNbAdults: (nbAdults: number) => void,
    nbChildren: number,
    setNbChildren: (nbChildren: number) => void,
    nbBabies: number,
    setNbBabies: (nbBabies: number) => void,
    childrensAges: number[],
    setChildrensAges: (childrensAges: number[]) => void,
}

export const SearchBarContext = React.createContext<SearchBarContextProps>({
    destinations: null,
    setDestinations: () => { },
    duration: null,
    setDuration: () => { },
    startDate: new Date(),
    setStartDate: () => { },
    endDate: null,
    setEndDate: () => { },
    roomCategory: null,
    setRoomCategory: () => { },
    product: null,
    setProduct: () => { },
    nbAdults: 2,
    setNbAdults: () => { },
    nbChildren: 0,
    setNbChildren: () => { },
    nbBabies: 0,
    setNbBabies: () => { },
    childrensAges: [],
    setChildrensAges: () => { },
})